// extracted by mini-css-extract-plugin
module.exports = {"sections":"styles_sections__2Hzt8","btnSelected":"styles_btnSelected__VuVED","btn":"styles_btn__3MWdZ"};